import Tooltip from '../../common/tooltip'
import { formatEmptyValue } from '../../../utils/common'
import { TrashAlt, CheckCircle } from '@styled-icons/boxicons-solid'

const InSpectionPointsRow = ({
  id,
  connector_name,
  inspection_points,
  harness_data,
  onDelete,
  wires_generated,
}) => {
  let harness = harness_data?.harness?.length > 0 ? harness_data?.harness : []
  return (
    <div className="flex flex-row items-center bg-white py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="w-3/12 px-2 break-all">
        <Tooltip message={connector_name}>
          <div>{formatEmptyValue(connector_name)}</div>
        </Tooltip>
      </div>
      <div className="w-5/12 px-2 table_text">
        <Tooltip message={inspection_points.join(', ')}>
          <div>{formatEmptyValue(inspection_points.join(', '))}</div>
        </Tooltip>
      </div>
      <div className="w-3/12 px-2 table_text">
        <Tooltip message={harness}>
          <div>{formatEmptyValue(harness)}</div>
        </Tooltip>
      </div>
      <div className="w-1/12 px-2 text-right">
        {wires_generated && (
          <span>
            <CheckCircle size="2rem" color="green" />
          </span>
        )}

        <span
          onClick={() => {
            onDelete(id)
          }}
          className="cursor-pointer p-2"
        >
          <TrashAlt size="2rem" color="#0189E9" />
        </span>
      </div>
    </div>
  )
}

export default InSpectionPointsRow
